
// import {
//   TransformWrapper,
//   TransformComponent,
//   useControls,
// } from "react-zoom-pan-pinch";
// import { FiZoomIn, FiZoomOut, FiRotateCcw, FiMaximize, FiExternalLink } from "react-icons/fi";
// import { useState } from "react";

// const Controls = ({ onRotate, onOpenNewTab }) => {
//   const { zoomIn, zoomOut, resetTransform } = useControls();

//   return (
//     <div className="absolute top-3 right-3 flex gap-3 z-50">
//       <button onClick={() => zoomIn()} className="p-2 bg-white rounded shadow">
//         <FiZoomIn size={20} />
//       </button>

//       <button onClick={() => zoomOut()} className="p-2 bg-white rounded shadow">
//         <FiZoomOut size={20} />
//       </button>

//       <button
//         onClick={onRotate}
//         className="p-2 bg-white rounded shadow"
//       >
//         <FiRotateCcw size={20} />
//       </button>

//       {/* ✅ Now correctly calls the prop passed from DocumentViewer */}
//       <button onClick={onOpenNewTab} className="p-2 bg-white rounded shadow">
//         <FiExternalLink size={20} />
//       </button>

//       <button
//         onClick={() => resetTransform()}
//         className="p-2 bg-white rounded shadow"
//       >
//         Reset
//       </button>

//       <button
//         onClick={() => document.documentElement.requestFullscreen()}
//         className="p-2 bg-white rounded shadow"
//       >
//         <FiMaximize size={20} />
//       </button>
//     </div>
//   );
// };

// export default function DocumentViewer({ url }) {
//   const [rotation, setRotation] = useState(0);

//   // ✅ Defined the function here where `url` is actually accessible
//   const handleOpenNewTab = () => {
//     if (url) window.open(url, "_blank");
//   };

//   return (
//     <div className="relative w-full h-[500px] bg-black overflow-hidden">
//       <TransformWrapper
//         initialScale={1}
//         minScale={0.2}
//         maxScale={6}
//         centerOnInit
//         limitToBounds={false}
//         // wheel={{ step: 0.15 }}
//         wheel={{ 
//     step: 0.001, // Try 0.05 or 0.02 for a very slow, smooth zoom
//     smoothStep: 0.005, // Helps make trackpad zooming smoother
//   }}
//       >
//         {/* ✅ Passed the function down to Controls as a prop */}
//         <Controls 
//           onRotate={() => setRotation((r) => r + 90)} 
//           onOpenNewTab={handleOpenNewTab} 
//         />

//         <TransformComponent wrapperClass="w-full h-full">
//           <div className="flex justify-center items-center w-full h-full">
//             <img
//               src={url}
//               alt="document"
//               style={{
//                 transform: `rotate(${rotation}deg)`,
//                 transition: "transform 0.2s ease",
//                 maxWidth: "none",
//                 maxHeight: "none",
//               }}
//               draggable={false}
//             />
//           </div>
//         </TransformComponent>
//       </TransformWrapper>
//     </div>
//   );
// }

// import {
//   TransformWrapper,
//   TransformComponent,
//   useControls,
// } from "react-zoom-pan-pinch";
// import { FiZoomIn, FiZoomOut, FiRotateCcw, FiMaximize, FiExternalLink } from "react-icons/fi";
// import { useState } from "react";

// const Controls = ({ onRotate, onOpenNewTab }) => {
//   const { zoomIn, zoomOut, resetTransform } = useControls();

//   return (
//     <div className="absolute top-3 right-3 flex gap-3 z-50">
//       <button onClick={() => zoomIn()} className="p-2 bg-white rounded shadow hover:bg-slate-50 transition-colors">
//         <FiZoomIn size={20} />
//       </button>

//       <button onClick={() => zoomOut()} className="p-2 bg-white rounded shadow hover:bg-slate-50 transition-colors">
//         <FiZoomOut size={20} />
//       </button>

//       <button
//         onClick={onRotate}
//         className="p-2 bg-white rounded shadow hover:bg-slate-50 transition-colors"
//       >
//         <FiRotateCcw size={20} />
//       </button>

//       <button onClick={onOpenNewTab} className="p-2 bg-white rounded shadow hover:bg-slate-50 transition-colors">
//         <FiExternalLink size={20} />
//       </button>

//       <button
//         onClick={() => resetTransform()}
//         className="p-2 bg-white rounded shadow font-medium hover:bg-slate-50 transition-colors"
//       >
//         Reset
//       </button>

//       <button
//         onClick={() => document.documentElement.requestFullscreen()}
//         className="p-2 bg-white rounded shadow hover:bg-slate-50 transition-colors"
//       >
//         <FiMaximize size={20} />
//       </button>
//     </div>
//   );
// };

// export default function DocumentViewer({ url }) {
//   const [rotation, setRotation] = useState(0);

//   // Opens the current image in a new browser tab
//   const handleOpenNewTab = () => {
//     if (url) window.open(url, "_blank");
//   };

//   return (
//     <div className="relative w-full h-[500px] bg-black overflow-hidden rounded-xl">
//       <TransformWrapper
//         initialScale={1}
//         minScale={0.2}
//         maxScale={6}
//         centerOnInit
//         limitToBounds={true} // Prevents dragging the image completely off-screen
//         wheel={{ 
//           step: 0.05, // Slows down the scroll zoom so it doesn't jump
//           smoothStep: 0.005, 
//         }}
//       >
//         <Controls 
//           onRotate={() => setRotation((r) => r + 90)} 
//           onOpenNewTab={handleOpenNewTab} 
//         />

//         {/* Removed extra div, flex applied directly to wrapper to fix zoom tracking math */}
//         {/* <TransformComponent wrapperClass="w-full h-full flex justify-center items-center">
//             <img
//               src={url}
//               alt="document"
//               style={{
//                 transform: `rotate(${rotation}deg)`,
//                 transition: "transform 0.2s ease",
//                 // Constrains weirdly cropped backend images perfectly to the box
//                 maxWidth: "100%",
//                 maxHeight: "100%",
//                 objectFit: "contain",
//               }}
//               draggable={false}
//             />
//         </TransformComponent> */}
//         <TransformComponent 
//           wrapperStyle={{ width: "100%", height: "100%" }}
//           contentStyle={{ width: "100%", height: "100%" }}
//         >
//             <img
//               src={url}
//               alt="document"
//               style={{
//                 transform: `rotate(${rotation}deg)`,
//                 transition: "transform 0.2s ease",

//                 // ✅ FIX: Force the image to explicitly fill the zoomable area while maintaining aspect ratio
//                 width: "100%",
//                 height: "100%",
//                 objectFit: "contain",
//               }}
//               draggable={false}
//             />
//         </TransformComponent>
//       </TransformWrapper>
//     </div>
//   );
// }



import {
  TransformWrapper,
  TransformComponent,
  useControls,
} from "react-zoom-pan-pinch";
import { FiZoomIn, FiZoomOut, FiRotateCcw, FiMaximize, FiExternalLink } from "react-icons/fi";
import { useState } from "react";

const Controls = ({ onRotate, onOpenNewTab }) => {
  const { zoomIn, zoomOut, resetTransform } = useControls();

  return (
    <div className="absolute top-3 right-3 flex gap-3 z-50">
      <button onClick={() => zoomIn()} className="p-2 bg-white rounded shadow">
        <FiZoomIn size={20} />
      </button>

      <button onClick={() => zoomOut()} className="p-2 bg-white rounded shadow">
        <FiZoomOut size={20} />
      </button>

      <button
        onClick={onRotate}
        className="p-2 bg-white rounded shadow"
      >
        <FiRotateCcw size={20} />
      </button>

      <button
        onClick={() => resetTransform()}
        className="p-2 bg-white rounded shadow"
      >
        Reset
      </button>

      <button onClick={onOpenNewTab} className="p-2 bg-white rounded shadow hover:bg-slate-50 transition-colors">
        <FiExternalLink size={20} />
      </button>

      <button
        onClick={() => document.documentElement.requestFullscreen()}
        className="p-2 bg-white rounded shadow"
      >
        <FiMaximize size={20} />
      </button>
    </div>
  );
};

export default function DocumentViewer({ url }) {
  const [rotation, setRotation] = useState(0);
  const handleOpenNewTab = () => {
    if (url) {
      window.open(url, "_blank");
    }
  };

  return (
    <div className="relative w-full h-[500px] bg-black overflow-hidden">

      <TransformWrapper
        initialScale={1}
        // initialScale={0.1}
        minScale={0.2}
        maxScale={6}
        centerOnInit
        limitToBounds={false}
        // limitToBounds={true}
        // wheel={{ step: 0.15 }}
        wheel={{ step: 0.001 }}
      >
        <Controls onRotate={() => setRotation((r) => r + 90)}
          onOpenNewTab={handleOpenNewTab} />

        <TransformComponent wrapperClass="w-full h-full">
          <div className="flex justify-center items-center w-full h-full">
            <img
              src={url}
              alt="document"
              style={{
                transform: `rotate(${rotation}deg)`,
                transition: "transform 0.2s ease",
                maxWidth: "none",
                maxHeight: "none",
              }}
              draggable={false}
            />
          </div>
        </TransformComponent>
      </TransformWrapper>
    </div>
  );
}